import { Breadcrumb as AntBreadcrumb, type BreadcrumbProps } from 'antd';
import type { FC } from 'react';
import { Link } from 'react-router';

type Props = {
  items: BreadcrumbProps['items'];
  separator?: BreadcrumbProps['separator'];
};

export const Breadcrumb: FC<Props> = ({ items, separator }) => {
  return (
    <AntBreadcrumb
      separator={separator}
      items={items?.map((item) => {
        const { href, ...restField } = item;
        return {
          ...restField,
          title: href ? <Link to={href}>{item.title}</Link> : item.title,
        };
      })}
    />
  );
};
